<template>
    <validation-observer v-slot="{ validate }" slim>
        <form @submit.prevent="update(validate)">
            <client-form :form="form" :loading="loading" @store="update"/>
        </form>
    </validation-observer>
</template>

<script>
import ClientService from '@services/client.service';
import ClientForm from './components/Form';
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
            form: {},
            loading: false
        };
    },
    watch: {
        locale() {
            this.getClient(this.$route.params.client_id);
        }
    },
    computed: {
        ...mapGetters(['locale']),
    },
    methods: {
        update(validate) {
            validate().then(valid => {
                if (valid) {
                    this.loading = true;
                    ClientService.update(this.$route.params.client_id, this.form).then(res => {
                        this.$toastr.s(this.$t('Updated'));
                        this.loading = false;
                        this.$router.push({name: 'clients'});
                    });
                }
            });
        },
        getClient(clientId) {
            ClientService.show(clientId).then(res => {
                this.form = res.client;
            });
        },
    },
    components: {
        ClientForm
    },
    created() {
        this.getClient(this.$route.params.client_id);
    }
};
</script>
